import { Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { DropdownOption } from '@maced/angular-components/lib/dropdown/dropdown.model';
import { INNER_WIDTH } from './global-navigation.constant';
import { ActivatedRoute } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { delay, of } from 'rxjs';

@Component({
  selector: 'app-global-navigation-header',
  templateUrl: './global-navigation.component.html',
  styleUrls: ['./global-navigation.component.scss']
})
export class GlobalNavigationHeaderComponent implements OnInit {
  isShowMenubar = false;
  isShowCascadebar = false;
  breadCrumbLimit: number = 20;
  public breadcrumbsName: any[] = [];
  cascadeMenus: any[] = [];
  isLinksClickable: boolean = false;
  nextIconClass: string = 'icon-chevron-slash';
  numberOfLinksVisible = 3;
  breadcrumbsContainer: string = 'breadcrumbsContainer';
  title = 'Welcome';
  subTitle = 'Overline';
  backUrl = '/button';
  logoUrl = '/';
  logo = '../../assets/images/logo-mee-black-mac.svg';
  smallLogo = '../../assets/images/logo.svg';
  logoAltText = 'Macmillan Education Everywhere Platform';
  moreMenuTitle = 'More';
  ariaLabels: any = {
    backButtonAriaLabel: "Back",
    closeButtonAriaLabel: "Close",
    hamburgerAriaLabel: "Menu",
    logoIcon: "Logo"
  };
  buttonType = 'button' as string;
  buttonId = 'globalHeaderMenu' as string;
  buttonLable = 'Global Header Menu';
  cascadeMenubarLabel = 'Back' as string;
  downloadBtnText = 'Download' as string ;

  cascadeMenuList = [
    [
      { id: 'Languages', name: 'Languages', icon: 'icon-chevron-right', isContainSubMenu: true },
      { id: 'Download', name: 'Downloaded app'}
     
    ],
    [
      { id: 'en', name: 'English (UK)', url:'./', queryParams: { selectedDropdownOptionId: 'en' }},
      { id: 'es', name: ' Español (México)', url:'./', queryParams: { selectedDropdownOptionId: 'es' }}
    ]
  ];
  options: DropdownOption[] = [
    {
      id: 'en',
      name: 'english',
      label: 'English (UK)',
      url: '/GlobalNavigationHeaderComponent',
      icon: 'icon-checked'
    },
    {
      id: 'es',
      name: 'español',
      label: 'Español (México)',
      url: '/GlobalNavigationHeaderComponent'
    }
  ];
  selectedOptions = this.options[0];
  isMobileView= false as boolean;
  isBrowser = true as boolean;
  backText="Back";
  
constructor(  @Inject(PLATFORM_ID) public platformId: Object,private route: ActivatedRoute, public elementRef: ElementRef){
  this.route.queryParams.subscribe(params => {
    if(params.selectedDropdownOptionId === 'es'){
      this.title = 'Bienvenido';
      this.downloadBtnText = 'Descargar'      
    } else{
      this.title = 'Welcome';
      this.downloadBtnText = 'Download';
    }
    if (params.selectedDropdownOptionId) {
      this.cascadeMenuList.forEach((parentObj) => {
        parentObj.forEach((obj:any) => {
          if (obj.id === params.selectedDropdownOptionId) {
            obj.trailingIcon = 'icon-check';
          } else {
            obj.trailingIcon = '';
          }
        });        
      });
    }
  });

  if (isPlatformBrowser(this.platformId)) {
    this.isBrowser = true;
    const windowWidth = window?.innerWidth;
    if ((windowWidth > 1024)) {
      this.isMobileView = false;
    } else {
      this.isMobileView = true;
    }
  }else{
    this.isBrowser = false;
  }
}

@HostListener('window:resize', ['$event'])
onResize(event: any) {
  if (event.target.innerWidth < INNER_WIDTH.innerWidth) {
    this.isMobileView = true;
  }else{
    this.isMobileView = false;
  }
}

ngOnInit(){
  if(this.cascadeMenuList && this.cascadeMenuList.length !== 0){
    this.cascadeMenus.push({
      isVisible: true,
      menus: this.cascadeMenuList[0]
    });
  }
}

  openMenu() {
    if (!this.isShowCascadebar) {
      this.isShowCascadebar = true;
    } else {
      this.isShowCascadebar = false;
    }
  }
hasTitleBar(index: number) {
  const windowWidth = window.innerWidth;
  if (windowWidth < 1023) {
    return true;
  } else if (index > 0) {
    return false;
  } else {
    return true;
  }
}
onClickCascadeClose() {
  this.isShowCascadebar = false;
  this.cascadeMenuList.forEach((parentObj: any) => {
    parentObj.forEach((obj: any) => obj.active = false);
  });
}
onClickCascadeBack(index: number) {
  const windowWidth = window.innerWidth;
  if (windowWidth < 1023) {
    this.cascadeMenus.splice(index, 1);
    this.breadcrumbsName.splice(index - 1, 1);
    this.numberOfLinksVisible = this.breadcrumbsName.length - 1
    if (this.cascadeMenus.length > 0) {
      this.cascadeMenus[this.cascadeMenus.length - 1].isVisible = true;
    }
  } else {
    this.cascadeMenus.splice(this.cascadeMenus.length - 1, 1);
  }
  if (this.cascadeMenus.length === 0) {
    this.onClickCascadeClose();
  }
}
onClickCascadeMenu(menu: any, index: number) {
  this.cascadeMenus.splice(index + 1, this.cascadeMenus.length - (index + 1));
  if (menu.isContainSubMenu) {
    this.cascadeMenus.push({
      name: this.backText,
      isVisible: true,
      menus: this.cascadeMenuList[index + 1]
    });
  }

  this.cascadeMenus.forEach((parentObj: any, i: number) => {
    const windowWidth = window.innerWidth;
    if (windowWidth < 1023) {
      if (i <= index && menu.isContainSubMenu) {
        parentObj.isVisible = false;
      }
    }
   if (i === index) {
      parentObj.menus.forEach((obj: any) => {
        if (obj.id === menu.id) {
          obj.trailingIcon = 'icon-check';
          obj.active = true;
        } else {
          obj.trailingIcon = '';
          obj.active = false;
        }
        return obj;
      });
    }
  });
}
}